module.exports = __webpack_public_path__ + "img/selected2-min.267b81fd.png";